import React, { useState, useEffect } from "react";
import {
  IonContent,
  IonPage,
  IonButton,
  IonText,
  IonCard,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
  IonLoading,
} from "@ionic/react";
import { useForm } from "react-hook-form";
import { useIntl } from "react-intl";
import Auth from "../../api/auth";
import InputItem from "../../components/formItems/InputItem";
import { ErrorMessage } from "@hookform/error-message";
const Forgot = () => {
  const {
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm({
    criteriaMode: "all",
  });
  const intl = useIntl();
  const [loading, setLoading] = useState(false);
  const [authError, setAuthError] = useState(null);
  const [feedback, setFeedback] = useState(null);

  useEffect(() => {
    const subscription = watch(() => {});
    return () => subscription.unsubscribe();
  }, [watch]);

  const onFinish = async (values) => {
    setLoading(true);
    Auth.sendPasswordResetEmail(values.email)
      .then(function () {
        setAuthError(null);
        setFeedback(true);
        setLoading(false);
      })
      .catch(function (error) {
        setAuthError(error.code);
        setLoading(false);
      });
  };

  const emailReg = /^([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|"([]!#-[^-~ \t]|(\\[\t -~]))+")@[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?)+$/;

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle>
            {intl.formatMessage({
              id: "app.mobile.forgot",
            })}
          </IonTitle>
          <IonButtons slot="start">
            <IonBackButton
              defaultHref="/login"
              text={intl.formatMessage({
                id: "app.mobile.login",
              })}
            />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonCard>
          <div style={{ padding: "16px 16px 0 16px" }}>
            <IonText color="muted">
              <h2>
                {intl.formatMessage({
                  id: "app.mobile.forms.user.reset_title",
                })}
              </h2>
              <p>
                {intl.formatMessage({
                  id: "app.mobile.forms.user.reset_subtitle",
                })}
              </p>
            </IonText>
          </div>
          <form onSubmit={handleSubmit(onFinish)}>
            <InputItem
              name="email"
              control={control}
              label={intl.formatMessage({
                id: "app.mobile.forms.user.email",
              })}
              rules={{
                required: `${intl.formatMessage({
                  id: "app.mobile.forms.user.email",
                })} ${intl.formatMessage({
                  id: "app.mobile.forms.requiredMessage",
                })}`,
                pattern: {
                  value: emailReg,
                  message: intl.formatMessage({
                    id: "app.mobile.forms.emailMessage",
                  }),
                },
              }}
            />
            <div className="errors_container">
              <ErrorMessage
                errors={errors}
                name="email"
                render={({ messages }) =>
                  messages &&
                  Object.entries(messages).map(([type, message]) => (
                    <p key={type}>{message}</p>
                  ))
                }
              />
            </div>

            {authError && (
              <IonText
                color="muted"
                style={{
                  padding: "20px",
                  display: "flex",
                  position: "absolute",
                  bottom: "40px",
                }}
              >
                <p
                  style={{
                    margin: "-20px 0 20px ",
                    width: "300px",
                    color: "red",
                  }}
                >
                  {intl.formatMessage({
                    id: `app.mobile.notifications.${authError}`,
                    defaultMessage: authError,
                  })}
                </p>
              </IonText>
            )}

            <div className="ion-padding">
              {feedback ? (
                <IonText color="success">
                  <p>
                    {intl.formatMessage({
                      id: "app.mobile.forms.user.resetLinkSent",
                    })}
                  </p>
                </IonText>
              ) : (
                <IonButton
                  expand="block"
                  className="ion-margin-top"
                  type="submit"
                  loading={loading}
                >
                  {intl.formatMessage({
                    id: "app.mobile.actions.send",
                  })}
                </IonButton>
              )}
            </div>
          </form>
        </IonCard>
        <IonLoading isOpen={loading} onDidDismiss={() => setLoading(false)} />
      </IonContent>
    </IonPage>
  );
};

export default Forgot;
